import React, { useState } from 'react';
import { BASE_PATH_PORTAL } from 'constants/general';
import './style.sass';

export default function BoxNuestraCompania() {

    const [menuView, setMenuView] = useState(false);

    const toggleClass = () => {
        setMenuView(!menuView);
    };

    return (
        <div className="boxClaroShop">
            <p onClick={toggleClass} className={menuView ? 'active' : null}>Claro Shop</p>
            <ul>
                <li><a href={`${BASE_PATH_PORTAL}/aviso-privacidad/`}  >Aviso de privacidad</a></li>
                <li><a href={`${BASE_PATH_PORTAL}/terminos-y-condiciones/`} >Términos y condiciones</a></li>
                <li><a href="https://blog.claroshop.com/" >Blog Claroshop</a></li>
            </ul>
        </div>
    )
}


